import { render } from "./TabSticky.vue?vue&type=template&id=b4913706&scoped=true"
import script from "./TabSticky.vue?vue&type=script&lang=js"
export * from "./TabSticky.vue?vue&type=script&lang=js"

import "./TabSticky.vue?vue&type=style&index=0&id=b4913706&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4913706"]])

export default __exports__